
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getSubscriptionUpgradeStatus",
      resolverType: "query",
      routePath: "/getSubscriptionUpgradeStatus",
      httpMethod: "POST",
    });
  